import styled from 'styled-components';

import { Header as TextHeader, Segment as SegmentLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled(SegmentLayoutComponent)`
  ${({ isSelectable, selected }) => isSelectable && `
    cursor: pointer;

    &.ui.segment {
      margin: 20px 0;

      ${selected ? 'box-shadow: 0px 0px 0px 2px #89E27E inset;' : 'box-shadow: 0px 0px 0px 0px #DEDEDF inset;'}

      :first-child {
        margin-top: 0;
      }

      :last-child {
        margin-bottom: 0;
      }
    }
  `}
`;

export const Content = styled.div`
  display: flex;
  align-items: center;

  ${(props) => (props.footer ? `
    justify-content: space-between;
    margin-top: 15px;
  ` : `
    margin-bottom: 10px;
  `)}
`;

export const Header = styled(TextHeader)`
  margin: 0;
`;

export const Text = styled(TextLayoutComponent)`
  ${(props) => props.date && `
    color: ${props.theme.color.dateColorText};
  `}

  ${(props) => props.withSpace && `
    margin-right: 10px;
  `}
`;

export const Link = styled.a``;

export const ContainerTag = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
`;

export const MarginTag = styled.div`
  margin: 1px 1px;
`;
